import { css } from 'lit';

export const uploadImageBaseStyles = 
  css`
    /*:host {
      position:relative;
    }*/

    .upload-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: 2px dashed var(--c-emphasize-sec);
      border-radius: 1rem;
      padding: 0;
      padding-block-end: 0;
      background-color: var(--c-background-light-red);
      text-align: center;
      color: var(--c-text-secondary);
      margin-block-start: 2rem;
    }

    .upload-container:hover {
      border-color: var(--c-emphasize);
    }

    .upload-container.preview {
      border: unset;
      background-color: unset;
    }

    .upload-info {
      font-size: 0.9rem;
      color: var(--c-text-secondary);
      margin-bottom: 1rem;
    }
    
    .upload-info svg{
      margin-block-start: 2rem;
      width: 11rem;
      height: 11rem;
    }

    .upload-button {
      margin-top: 3rem;
      padding: 0.75rem 1.5rem;
      background-color: var(--c-emphasize);
      color: var(--c-background-light);
      border: none;
      border-radius: 2rem;
      cursor: pointer;
      font-weight: bold;
      font-size: 1rem;
      padding: 10px 20px;
      cursor: pointer;
      font-size: 1.8rem;
      margin-block: 4rem;
      background-color: var(--c-emphasize-sec);
      border: 2px solid var(--c-emphasize-sec);
      background: var(--btn-pri-bg);
      color: var(--btn-pri-text);
      border-radius: 5rem;
      min-width: 9rem;
    }
    .upload-button.use-photo {
      margin-top: unset;
      margin-block: 1rem;
      margin-block-start: 3rem;
      font-size: 1.8rem;
    }

    .upload-button:hover {
      background-color: var(--c-button-hover);
      border: 2px solid var(--c-button-hover);
    }

    #file-input {
      display: none;
    }

    .drag-text {
      margin-top: 1rem;
      font-size: 2rem;
      color: var(--c-text-primary);
      margin-inline: 1rem;
    }

    .preview-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 1rem;
      padding: 0;
      padding-block-end: 0;
      background-color: var(--c-background-light);
    }
    
    .preview-image {
      position: relative;
      max-width: 100%;
      max-height: 28vh;
      margin-bottom: 1rem;
      border-radius: 10px;
      border:1px black solid;
      transition: transform 0.3s ease-in-out; /* Smooth transition for zoom effect */
    }

    .preview-image:hover {
      /*transform: scale(1.5);*/ /* Zoom effect on hover */
    }

    .cancel-button {
      padding: 10px 20px;
      cursor: pointer;
      font-size: 2rem;
      border: unset;
      color: var(--c-cancel-image-upload);
      border-radius: 5rem;
      min-width: 9rem;
      background: unset;
    }

    .cancel-button:hover {
      background-color: unset;
      border: unset;
      color:unset;
    }

    .buttons-container {
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    .upload-image-icon {
      position: absolute;
      top: -24px;
      right: 24px;
      cursor: pointer;
      width: 10px;
      z-index: 10;
    }

    .image-and-icon {
      transition: transform 0.3s ease-in-out; /* Smooth transition for zoom effect */
      max-width:20vw;
      position:relative;
    }

    /*.image-and-icon:hover {
      transform: scale(1.5);
    }*/

    .menu {
      position: absolute;
      top: 5rem;
      right: 2rem;
      background: white;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      border-radius: 0.5rem;
      overflow: hidden;
      z-index: 10;
    }

    .menu-item {
      padding: 1rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 2rem;
      font-weight: bold;
      color: #0D2D5F;
    }
    
    .menu-item:nth-child(2) {
      color: #F62B68;
    }
     
    .menu-item:hover {
      background: #f2f2f2;
    }

    
  `
;
